// TabMenu.js
import React from 'react'

const TabMenu = ({ currentTab, setCurrentTab }) => (
  <ul className="flex flex-wrap w-full">
    <li className="w-1/2">
      <a
        onClick={() => setCurrentTab('course_library')}
        className={`text-center w-full cursor-pointer text-lg inline-block font-bold py-2 px-4 ${currentTab === 'course_library' ? 'text-black border-b-2 border-secondary-600' : 'text-[#B3B2B2]'}`}
      >
        Course Library
      </a>
    </li>
    <li className="w-1/2">
      <a
        onClick={() => setCurrentTab('achievements')}
        className={`text-center w-full cursor-pointer text-lg inline-block font-bold py-2 px-4 ${currentTab === 'achievements' ? 'text-black border-b-2 border-secondary-600' : 'text-[#B3B2B2]'}`}
      >
        Achievements
      </a>
    </li>
  </ul>
)

export default TabMenu
